import { Box, Skeleton, Typography } from "@mui/material";
import React from "react";

const SkeletonSubWorkTable = () => {
    return (
        <>
            {[...Array(1)].map((_) => (
                <Skeleton variant="rectangular" sx={{ mb: 1 }} height={50} />
            ))}
        </>
    );
};

export default SkeletonSubWorkTable;
